import React , {Component} from "react";
import {  Formik, Form, Field } from 'formik';
import axios from 'axios';
import { MenuItem, LinearProgress, Typography, Grid, Breadcrumbs, Tooltip, Fab, Modal, Snackbar } from '@mui/material';
import * as yup from 'yup';
import {Link, useParams} from 'react-router-dom';
import {ExcelRenderer} from 'react-excel-renderer';
import { TextField } from 'formik-mui';
import { styled } from "@mui/material/styles";
import GridItem from "../../components/Grid/GridItem.jsx";
import GridContainer from "../../components/Grid/GridContainer.jsx";
import Card from "../../components/Card/Card.jsx";
import CardHeader from "../../components/Card/CardHeader.jsx";
import CardBody from "../../components/Card/CardBody";
//import Table from "../../components/Table/Table.jsx";
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import { baseUrl } from '../../components/shared/baseUrl';
import { mongoUrl } from '../../components/shared/mongoUrl';
import InsertPhotoIcon from '@mui/icons-material/InsertPhoto';
import AttachFileIcon from '@mui/icons-material/AttachFile';
//import Table from "@mui/material/Table";
import Table from "@mui/material/Table";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import Button from "../../components/CustomButtons/Button.jsx";
import withRouterCompat from '../../actions/routerWrapper.jsx';


const StyledcardTitle = styled('div')(({ theme }) => ({
    color: "#FFFFFF",
    marginTop: "0px",
    minHeight: "auto",
    fontWeight: "300",
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    marginBottom: "3px",
    textDecoration: "none"
}));

const StyledPaper1 = styled('div')(({ theme }) => ({
    position: 'absolute',
    width: 300,
    backgroundColor: theme.palette.background.paper,
    border: '2px solid #000',
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
}));

const StyledModal = styled('div')({
  alignItems: 'center',
  justifyContent: 'center',
  display: 'flex'
});
 

const standard = [
    {
        value: 'VI',
        label: 'VI'
    },
    {
        value: 'VII',
        label: 'VII'
    },
    {
        value: 'VIII',
        label: 'VIII'
    },
    {
        value: 'IX',
        label: 'IX'
    },
    {
        value: 'X',
        label: 'X'
    },
    {
        value: 'XI',
        label: 'XI'
    },
    {
        value: 'XII',
        label: 'XII'
    }

]



const previewStyle = {
    maxHeight: "100px",
    maxWidth: "100px"
  }

  const validationSchema = yup.object().shape({
  
    title: yup
      .string()
      .min(6, "Title is too short "),
  
    description: yup
      .string()
      .min(2, "Too Short")
      .max(30, "Too Long!"),
    teachers:yup.array().of(
        yup.object().shape({
        value: yup
        .string()
        .email()
        .required()
    })
    )
  })


class CreateClass extends Component {

    constructor(props) {
        super(props)
        this.state = {
            id:'',
            file: '',
            url: null,
            title:'',
            std:'',
            classimage:'',
            clas:[],
            loading:true,
            teachers:[],
            coTeach:[],

            rows:'',
            cols:'', 
            studentlist:[],
            schemalist:[{
                "Name":'',
                "Email":''
            }],
            totallist:[],
            std:'',
            edit:false,
            uploadSuccess:false,
            uploadStudents:false,
            errorstudent:'',
            checkupload:false,
            checkvalidstudentemail:false,
            delstudent:false,
            addstudent:false,
            currStudent:{},
            errors:'',
            name:'',
            email:'',
            openSnackAdd:false,
            openSnackDel:false,

        };

        this.handleUploadImage = this.handleUploadImage.bind(this);
        this.uploadbutton = this.uploadbutton.bind(this);
        this.handleUploadClick = this.handleUploadClick.bind(this);        
        this.addcoTeacher = this.addcoTeacher.bind(this);
        this.removecoTeacher = this.removecoTeacher.bind(this);
        this.handlecoChange= this.handlecoChange.bind(this); 
        this.editbutton= this.editbutton.bind(this); 
        this.handlestdChange= this.handlestdChange.bind(this);
        this.validateTitle=this.validateTitle.bind(this); 
        this.validateEmail=this.validateEmail.bind(this);
        this.validateStd=this.validateStd.bind(this);
        this.validateName=this.validateName.bind(this);
        this.validateStudentEmail=this.validateStudentEmail.bind(this);
        this.validateStudent=this.validateStudent.bind(this);         
        this.cancelImagebutton = this.cancelImagebutton.bind(this);
        this.cancelFilebutton = this.cancelFilebutton.bind(this);
        this.deleteStudent = this.deleteStudent.bind(this);
        this.yesdeleteStudent = this.yesdeleteStudent.bind(this);
        this.nodeleteStudent = this.nodeleteStudent.bind(this);
        this.addStudent = this.addStudent.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.handleAddClose = this.handleAddClose.bind(this);
        this.onChange = this.onChange.bind(this);
        this.addNewStudent=this.addNewStudent.bind(this);
        this.handleCloseSnack=this.handleCloseSnack.bind(this);
    }
  
componentDidMount(){
    const id = this.props.params.classId;
    //console.log(id);

    axios.get(`${baseUrl}class/${id}`)
    .then((response) => {
        
    const studentList = [];
        response.data.students.map((item, i) =>{
          //console.log(item)
          studentList.push(
            {
              No:i+1,
              Name:item.Name,
              Email:item.Email
            }
          )
        })
    
    this.setState({
        clas:response.data,
        id:response.data._id,
        title:response.data.title,
        classimage:response.data.image,
        std:response.data.std,
        studentlist:studentList,
        coTeach:response.data.coTeachers
    })

    this.setState({loading: !this.state.loading});

    })
    .catch((error)=>{
    console.log(error);
    });

}

addNewStudent(){
    var name = this.state.name
    var email = this.state.email
    console.log(name +'Email'+email)
    // this.setState({
    //     studentlist: [...this.state.studentlist, {"No":'',"Name":'' ,"Email":''}]
    // })
    if(name===''||email===''){
        this.setState({
            errors:'Please enter name and email'
          });
    }
    else if(!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(email) || name.length <='5'){
        this.setState({
            errors:'Please enter valid email or name'
          });
    }
    else{
        this.setState({
            errors:''
          });
    var index = this.state.studentlist.length;
    //console.log(index)
    console.log(this.state.studentlist[index-1])
    
    var list = new Array(this.state.studentlist.length+1)
    var newIndex = list.length;
    console.log(newIndex)

    for(let i=0; i<newIndex;i++){
        list[i] = {
            'No':'',
            'Name':'',
            'Email':''
        };
    }

    console.log(list)

    this.state.studentlist.map((item, i) =>{
        list[i].No = item.No
        list[i].Name = item.Name
        list[i].Email = item.Email
    })
    list[newIndex-1].No = newIndex
    list[newIndex-1].Name = name
    list[newIndex-1].Email = email

    console.log(list)

   

    this.setState({
        studentlist:list,
        addstudent:!this.state.addstudent,
        openSnackAdd: true,

      });
      
    }

}

handleClose() {
    this.setState({
      delstudent:!this.state.delstudent
    });
  }

  handleAddClose() {
    this.setState({
      addstudent:!this.state.addstudent
    });
  }

deleteStudent(item){
    //console.log('button clicked')
    console.log(item)

    this.setState({
        delstudent:!this.state.delstudent,
        currStudent:item.item
    })
    
}
yesdeleteStudent(){
    console.log(this.state.currStudent.Email)
    var index=-5;
    this.state.studentlist.map((stu, i) =>{
        console.log(stu)

        if(stu.Email===this.state.currStudent.Email){

            index=i
        }
    })
    this.state.studentlist.splice(index, 1)
    this.setState({
        studentlist:this.state.studentlist
    })

    this.setState({
        delstudent:!this.state.delstudent,
        currStudent:{},
        openSnackDel:true 

    })
    
}

nodeleteStudent(){
    //console.log(this.state.currStudent)
    this.setState({
        delstudent:!this.state.delstudent,
        currStudent:{}
    })
}

addStudent(){
    //console.log(this.state.currStudent)
    this.setState({
        addstudent:!this.state.addstudent,
    })
}

cancelImagebutton() {
    this.setState({
      file:'',
      url:''
    });
  }
  cancelFilebutton() {
    this.setState({
      rows:'',
      uploadStudents:false,
      checkupload:false
    });
  }

handlestdChange(event){
    this.setState({
        std:event.target.value,
      })
}

validateName(value) {
    let error;
    //console.log(value.length);
    value = this.state.name
    if(value.length==0){
        error = 'Please enter your name'
    }
    else if(value.length<3){
          error = 'Name is too short'
       }
    else if(value.length>=30){
        error = 'Name too long'
    }
    return error;
  }

  validateStudentEmail(value) {
    let error;
    //console.log(value.length);
    value = this.state.email
    if(value.length==0){
      error = 'Please enter email address'
     }
    else if(!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value)){
      error = 'Invalid email address'
  }
    return error;
  }
validateStd(value) {
    let error;
    console.log(value);
    if(this.state.std ==''){
          error = 'Please select std'
       }
    return error;
  }

  validateStudent(value) {
    let error;
    this.state.totallist.map((student, index)=>{
        value=student.Email
        if(!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value)){
            
            this.setState({
                errorstudent:'Invalid email address of student',
                checkvalidstudentemail:!this.state.checkvalidstudentemail
              })
        }
    })
        this.setState({
            uploadStudents:!this.state.uploadStudents
          }) 
      
    return error;
  }
  
validateEmail(value) {
    let error;
    this.state.coTeach.map((teacher, index)=>{
        value=teacher.Email
        if(!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value)){
            error = 'Invalid email address'
        }
    })
    console.log(value);

    
    console.log(error);

    return error;
  }

validateTitle(value) {
    let error;
    //console.log(value.length);
    if(value.length==0){
        error = 'Every class must have a title'
    }
    else if(value.length<5){
          error = 'Title is too short'
       }
    else if(value.length>=30){
        error = 'Title too long'
    }
    return error;
  }

uploadbutton(){
    const data=new FormData();
    //// imageFile is set as single key in backend 
    data.append('file', this.state.file)   
    let url = `${baseUrl}fileupload/files`;


    axios.post(url, data)
    .then(response => {
        this.setState({
            classimage:response.data.file.filename,
            uploadSuccess:!this.state.uploadSuccess,
          })
        console.log(response)
    })
    .catch(errors => console.log(errors));

}

handleUploadImage(event){
        this.setState({
            file: event.target.files[0],
            url: URL.createObjectURL(event.target.files[0])
          })
          
          if(this.state.uploadSuccess===true){
            this.setState({
                uploadSuccess:!this.state.uploadSuccess
              }) 
          }
        };



///////function for rendering excel files//////////////////
handleUploadClick(event){
    let fileObj = event.target.files[0];
  
    ExcelRenderer(fileObj, (err, resp) => {
        if(err){
          console.log(err);            
        }
        else{
          this.setState({
            cols: resp.cols,
            rows: resp.rows
          });
        }

         this.setState({
             rows: this.state.rows.slice(1)
           });

        let t = []
         {this.state.rows.map((item, i) => (
            
             t[i] = {...item}

         ))}
         this.setState({
            studentlist:[]
        })
        

          {t.map((item, i) => (
            this.setState({
                studentlist: [...this.state.studentlist, {"Name":'' ,"Email":''}]
            }),
            
             this.state.studentlist[i].Name = item[0],
             this.state.studentlist[i].Email = item[1],
    
             console.log(i, item[0])
             
         ))}
         this.setState({
            totallist:this.state.studentlist,
            errorstudent:'',
        })
        if(this.state.checkvalidstudentemail===true){
            this.setState({
                checkvalidstudentemail:!this.state.checkvalidstudentemail
            })
        }

        if(this.state.checkupload===false){
        this.setState({
            checkupload:!this.state.checkupload,
            uploadStudents:!this.state.uploadStudents
          })
        }
        else if(this.state.uploadStudents===false){
            this.setState({
                uploadStudents:!this.state.uploadStudents
              })
            }

      }); 

                   
      
    };





///////////////////////////////////function for changing coTeachers/////////////////////////////////

addcoTeacher(){
    this.setState({
        coTeach: [...this.state.coTeach, {"Id":'' ,"Email":''}]
    })

} 


removecoTeacher(index){
    this.state.coTeach.splice(index, 1)
    this.setState({
        coTeach:this.state.coTeach
    })
}


handlecoChange(e, index){

    this.state.coTeach[index].Email = e.target.value

    this.setState({
        coTeach: this.state.coTeach
    });

}
    
editbutton(){
    this.setState({edit: !this.state.edit})
  
  }
  onChange = event => {
    this.setState({ [event.target.name]: event.target.value });
  }
       
  handleCloseSnack = () => {
    this.setState({ 
        openSnackAdd: false,
        openSnackDel:false 
    });
  }

    render(){
           
        const { classes } = this.props;

        //console.log(this.state.studentlist[0]);
        


      return (
       
        <div>
            {this.state.loading!==true?
           <GridContainer>
                <GridItem xs={12} sm={12} md={12}>

                    <Breadcrumbs separator={<NavigateNextIcon fontSize="small" />} aria-label="breadcrumb">
                        <Link color="inherit" to="/admin/dashboard">
                            Dashboard
                        </Link>
                        <Link color="inherit" to={`/admin/dashboard/viewclass/${this.state.clas._id}`}>
                            {this.state.clas.title}
                        </Link>
                    <Typography color="textPrimary">Edit Class</Typography>
                    </Breadcrumbs>
                </GridItem>
                <GridItem xs={12} sm={12} md={12}>
                        
                    <Card>
                        <CardHeader color="primary">
                            <StyledcardTitle>
                                <p>Update details of class</p>
                            </StyledcardTitle>
                        </CardHeader>
                        <Snackbar
                            anchorOrigin={{ vertical: 'top',
                            horizontal: 'center', }}
                            open={this.state.openSnackAdd}
                            onClose={this.handleCloseSnack}
                            message="Student Added"
                            autoHideDuration={6000}
                            //key={vertical}
                        />
                        <Snackbar
                            anchorOrigin={{ vertical: 'top',
                            horizontal: 'center', }}
                            open={this.state.openSnackDel}
                            onClose={this.handleCloseSnack}
                            message="Student Deleted"
                            autoHideDuration={6000}
                            //key={vertical}
                        />
                <Formik
                    initialValues={{
                    title: this.state.title,
                    std: this.state.std,
                    coTeach: this.state.coTeach,

                    students:this.state.studentlist,
                    classimage:this.state.classimage,

                    }}

                    validationSchema={validationSchema}

                    onSubmit={(values, {setSubmitting}) => {
                    setTimeout(() => {
                        setSubmitting(false);
                        // {(this.state.file !== '') ? values.classimage=`assets/images/${this.state.file.name}`: values.classimage=this.state.classimage}
                        
                        console.log(values.classimage)
                        this.setState({edit: !this.state.edit})
                        values.coTeach = this.state.coTeach
                        values.students = this.state.studentlist
                        values.classimage = this.state.classimage
                        //alert(JSON.stringify(values, null, 2));

                        const classDetails = {
                            title: values.title,
                            image:values.classimage,
                            std:values.std,
                            coTeachers:values.coTeach,
                            students:values.students,
                        }

                        axios.put(`${baseUrl}class/${this.state.id}`, classDetails)
                        .then(res => 
                            {
                                console.log(res.data)   
                            });


                    }, 500);
                    }}
                >
                    {({submitForm, isSubmitting, touched, errors}) => (
                        <Form>
                         
                                <CardBody>
                                    <GridContainer>
                                        <GridItem xs={12} sm={12} md={4}>
                                            <Field
                                            component={TextField}
                                            type="text"
                                            label="Title"
                                            name="title"
                                            {...this.state.edit!==true ? {disabled:true} : {disabled:false}}
                                            validate={this.validateTitle}

                                            />
                                        </GridItem>
                                        <Modal
                                            open={this.state.delstudent}
                                            onClose={this.handleClose}
                                            aria-labelledby="fb-dialog-title"
                                            >
                                            <StyledModal>
                                                <StyledPaper1>
                                                
                                                    <p id = "fb-dialog-title">
                                                        Are you sure you want to delete {this.state.currStudent.Name}  
                                                        </p>
                                                        <p>
                                                        <Button
                                                        size="small"
                                                        color="primary"
                                                        variant="contained"
                                                        onClick={this.yesdeleteStudent}
                                                        >
                                                        Yes
                                                        </Button>
                                                        or
                                                        <Button
                                                        size="small"
                                                        color="primary"
                                                        variant="contained"
                                                        onClick={this.nodeleteStudent}
                                                        >
                                                        No
                                                        </Button>

                                                    </p>
                                                </StyledPaper1>
                                            </StyledModal>
                                          </Modal>
                                          <Modal
                                            open={this.state.addstudent}
                                            onClose={this.handleAddClose}
                                            aria-labelledby="fb-dialog-title"
                                            >
                                            <StyledModal>
                                            <StyledPaper1>
                                            
                                              <p>{this.state.errors}</p>
                                                <h4 id = "fb-dialog-title"> Add a New Student</h4>
                                                <p>
                                                <Field
                                                    component={TextField}
                                                    label="Name"
                                                    type="text"
                                                    name="name"
                                                    onChange={this.onChange}
                                                    value={this.state.name}
                                                    //error={errors.email}
                                                    fullWidth={true}
                                                    validate={this.validateName}
                                                />
                                                </p>
                                                <p>
                                                <Field
                                                    component={TextField}
                                                    label="Email "
                                                    type="email"
                                                    name="email"
                                                    onChange={this.onChange}
                                                    value={this.state.email}
                                                    //error={errors.email}
                                                    fullWidth={true}
                                                    validate={this.validateStudentEmail}
                                                />
                                                </p>
                                                <p>
                                                <Button
                                                  size="small"
                                                  color="primary"
                                                  variant="contained"
                                                  onClick={this.addNewStudent}
                                                >
                                                  Yes
                                                </Button>
                                    
                                                <Button
                                                  size="small"
                                                  color="primary"
                                                  variant="contained"
                                                  onClick={this.handleAddClose}
                                                >
                                                  No
                                                </Button>

                                              </p>
                                            </StyledPaper1>
                                            </StyledModal>
                                          </Modal>
                                        

                                        <GridItem xs={12} sm={12} md={4}>
                                            
                                            {
                                                this.state.coTeach.map((teacher, index) =>{
                                                    return(
                                                        <div key={index} >

                                                            <Field
                                                                component={TextField}
                                                                type="text"
                                                                label="Enter email address of teacher"
                                                                name="description"
                                                                fullWidth= {true}
                                                                value={teacher.Email}
                                                            {...this.state.edit!==true ? {disabled:true} : {disabled:false}}

                                                                onChange={(e)=>this.handlecoChange(e, index)}
                                                                validate={this.validateEmail}
 
                                                            />
                                                            <Tooltip
                                                                arrow
                                                                title="Click to remove teacher"
                                                                placement="bottom">
                                                                <Fab
                                                                color="default"
                                                                variant="extended"
                                                                size="small"
                                                                onClick={e => this.removecoTeacher(index)}
                                                                >
                                                                <RemoveIcon />
                                                                Remove Teacher
                                                                </Fab>
                                                            </Tooltip>
                                                        </div>
                                                    )
                                                })
                                            }
                                            <div>
                                            
                                            <Tooltip
                                                arrow
                                                title="Click to add new teacher"
                                                placement="bottom">
                                               <Fab
                                                variant="extended"
                                                color="default"
                                                size="small"
                                                onClick={this.addcoTeacher}
                                                >
                                                <AddIcon />
                                                Add Teacher 
                                               </Fab>
                                              
                                            </Tooltip>
                                            </div>
                                            
                                        </GridItem>
                                        
                                        <GridItem xs={12} sm={12} md={4}>

                                            <Field
                                            component={TextField}
                                            type="text"
                                            name="std"
                                            label="std"
                                            select
                                            variant="standard"
                                            helperText="Please select"
                                            margin="normal"
                                            validate={this.validateStd}
                                            {...this.state.edit!==true ? {disabled:true} : {disabled:false}}

                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                            >
                                            {standard.map((option) => (
                                                <MenuItem key={option.value} value={option.value}>
                                                {option.label}
                                                </MenuItem>
                                            ))}
                                            </Field>

                                        </GridItem>
                                        <GridItem xs={12} sm={12} md={6}>
                                            <p>Update Details of students</p>
                                            <label htmlFor="student">
                                                <input
                                                accept="xlsx/*"
                                                id="student"
                                                multiple
                                                style={{ display: "none" }}
                                                type="file"
                                                name="student"
                                                onChange={this.handleUploadClick}
                                                {...this.state.edit!==true ? {disabled:true} : {disabled:false}}

                                                />
                                                <Fab color="secondary" aria-label="add" 
                                                    variant="extended"
                                                    size="medium"
                                                    component="span">
                                                    <AttachFileIcon /> Add Excel File
                                                </Fab>
                                            </label>
                                             {this.state.errorstudent}
                                        {this.state.checkupload===true?
                                            this.state.uploadStudents===true?
                                            
                                            <div>
                                            <Button color="success" onClick={this.validateStudent} 
                                            disabled={this.state.checkvalidstudentemail}>
                                                upload 
                                            </Button>
                                            <Button color="danger" onClick={this.cancelFilebutton}>
                                                cancel 
                                            </Button>
                                            </div>:
                                            this.state.checkvalidstudentemail===false?
                                            <p>uploaded successfully</p>:<p>Error Upload again</p>:null}
   
                                        </GridItem>
                                        <GridItem xs={12} sm={12} md={4}>
                                            <p>Update image for Class</p>
                                            <label htmlFor="classimage">
                                                <input
                                                accept="image/*"
                                                style={{ display: "none" }}
                                                id="classimage"
                                                multiple
                                                type="file"
                                                name="classimage"
                                                label="Upload image here"
                                                onChange={this.handleUploadImage}
                                                {...this.state.edit!==true ? {disabled:true} : {disabled:false}}
                                                />
                                                <Fab color="secondary" aria-label="add" 
                                                        variant="extended"
                                                        size="medium"
                                                        component="span">
                                                        <InsertPhotoIcon /> Add Image
                                                </Fab>
                                            </label>
                                            {this.state.file!=='' ?this.state.uploadSuccess!==true?
                                            <div>
                                            <Button color="success" onClick={this.uploadbutton}>
                                                upload 
                                            </Button>
                                            <Button color="danger" onClick={this.cancelImagebutton}>
                                                cancel 
                                            </Button></div>:<p>
                                                uploaded successfully
                                            </p>:null}
                                            {this.state.file===''?this.state.classimage.substring(0, 6)!=='assets'?
                                            <img src={mongoUrl+this.state.classimage} style={previewStyle}/>
                                            :<img src={baseUrl+this.state.classimage} style={previewStyle}/>
                                            :<img src={this.state.url} style={previewStyle}/>}                                       
                                        </GridItem>
                                    
                                        <GridItem xs={12} sm={12} md={6}>
                                            <Card>
                                                <CardHeader color="warning">
                                                <StyledcardTitle>
                                                    <h4> Current Student Details</h4>
                                                </StyledcardTitle>
                                                </CardHeader>
                                                <CardBody>
                                                    <Table>
                                                        <TableHead key={"header"}>
                                                        {Object.keys(this.state.studentlist[0]).map((key) => (
                                                            <TableCell>{key}</TableCell>
                                                                    ))}
                                                                 <TableCell>
                                                                    <div>
                                                                        <Tooltip
                                                                            arrow
                                                                            title="Click to add new teacher"
                                                                            placement="bottom">
                                                                            <Fab
                                                                                variant="extended"
                                                                                color="default"
                                                                                size="small"
                                                                                {...this.state.edit!==true ? {disabled:true} : {disabled:false}}
                                                                                onClick={this.addStudent}
                                                                                >
                                                                                <AddIcon />
                                                                                Add Student
                                                                            </Fab>
                                                                        
                                                                        </Tooltip>
                                                                    </div>
                                                                </TableCell>   
                                                        </TableHead>
                                                        <TableBody>
                                                        {this.state.studentlist.map((item) => (

                                                            <TableRow key={item.id}>
                                                                {Object.values(item).map((val) => (
                                                                <TableCell>{val}</TableCell>
                                                                ))}
                                                                <TableCell>
                                                                    <Button color="danger" 
                                                                    variant="contained"
                                                                    {...this.state.edit!==true ? {disabled:true} : {disabled:false}}
                                                                    onClick={e => this.deleteStudent({item})} >
                                                                    Delete
                                                                    </Button>
                                                                </TableCell>
                                                            </TableRow>
                                                            ))}
                                                        </TableBody>
                                                    </Table>
                                                </CardBody>
                                            </Card>
                                        </GridItem>
                                    </GridContainer>
                                </CardBody>
                            
                           
                            {isSubmitting && <LinearProgress />}
                            <GridItem xs={12}>
                            {this.state.edit === true ? 
                                <Button color="primary" onClick={submitForm} disabled={isSubmitting}> 
                                    Update Details
                                </Button> :
                                <Button color="primary" onClick={this.editbutton}>
                                    Edit Details
                                </Button> }
                            </GridItem>
                        </Form>
                     
                    )}
                </Formik>
            </Card>
        </GridItem>
        </GridContainer>:null}
        </div>
      );

  }
}

  export default withRouterCompat(CreateClass);